import speech, { useSpeechRecognition } from "react-speech-recognition";
import { useState, useEffect } from "react";

function App() {
  const apikey = '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'
  const { listening, transcript } = useSpeechRecognition()
  const [thinking, setthinking] = useState(true);
  const [aiText, setaiText] = useState();
  async function callApi(message) {
    setthinking(true)
    const data = await fetch('https://api.openai.com/v1/chat/completions', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer     <!-- How to change your own map point
        1. Go to Google Maps
        2. Click on your location point
        3. Click "Share" and choose "Embed map" tab
        4. Copy only URL and paste it within the src="" field below
-->
                    <!--  <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3647.3030413476204!2d100.5641230193719!3d13.757206847615207!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf51ce6427b7918fc!2sG+Tower!5e0!3m2!1sen!2sth!4v1510722015945"
                        width="100%" height="395" frameborder="0" style="border:0" allowfullscreen></iframe>
                </div> --> ${apikey}`
      },
      body: JSON.stringify({
        messages: [{
          role: "user",
          content: message
        }
        ],
        model: 'gpt-3.5-turbo'
      }),
    }).then((res) => res.json())
    setthinking(false)
    return data.choices[0].message.content
  }

  useEffect(() => {

    if (!listening && transcript) {
      callApi(transcript).then((response) => {
        const speechSynthesis = window.speechSynthesis;

        const utterance = new SpeechSynthesisUtterance(response);
        speechSynthesis.speak(utterance);
        setaiText(response)

      })

    }
  }, [transcript, listening])

  return (
    <div>
      <div style={{width:'100%',backgroundColor:'darkcyan',paddingTop:'10px',paddingBottom:'10px',margin:0}}><a href="https://hostel-stu.netlify.app/" style={{textDecoration:'none',color:'white'}}>Home</a></div>
      {
        listening ? (
          <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
            
            <img src="../listening.gif" width='200px' height='200px'/>
            
          </div>
        ) : (
          <p>click the button and ask me anything</p>
        )

      }
      <button onClick={() => {
        speech.startListening()
      }} >Ask me anything</button>
      
      {transcript && (
        <div style={{color:'white',fontWeight:'bold',padding:'20px',background:'darkgray', marginTop:'50px'}}>{transcript}</div>
      )}
      {
        thinking && (
          <p>{thinking}</p>
        )
      }
      {
        setaiText && (
          <div style={{color:'white',padding:'20px',background:'black', marginTop:'50px'}}>
            {aiText}
            </div>
        )
      }
    </div>
  )
}

export default App;